module.exports = __webpack_public_path__ + "static/awesome-face-43de8a01e24e0f6ffab07bd072786696.jpg";